<template dark>
  <div class="renderPage reporte-container animate-fade-in">
    <!-- Main Toolbar -->
    <v-toolbar color="primary" dark flat class="mb-4 rounded-xl" height="64">
      <v-icon class="mr-3" size="28">mdi-store-cog-outline</v-icon>
      <v-toolbar-title class="text-subtitle-1 text-sm-h6 font-weight-black px-0 text-uppercase letter-spacing-1">
        Gestión de Bancas
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon color="white" to="/home" class="glass-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Tab Navigation -->
    <v-card class="glass-card mb-6 rounded-xl overflow-hidden" elevation="0">
      <v-tabs background-color="transparent" class="custom-tabs" fixed-tabs center-active v-model="tab2">
        <v-tab key="cia_registrados" @click="limpiar()" class="font-weight-bold">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          Registradas
        </v-tab>
        <v-tab key="cia_nuevos" @click="limpiar()" class="font-weight-bold">
          <v-icon left>mdi-pencil-box</v-icon>
          Banca
        </v-tab>
      </v-tabs>
    </v-card>

    <v-tabs-items v-model="tab2" class="transparent-tabs-item">
      <!-- TAB: BANCAS REGISTRADAS -->
      <v-tab-item key="cia_registrados">
        <v-card class="glass-card rounded-xl overflow-hidden" elevation="0">
          <div class="px-6 py-4 border-bottom header-glass d-flex align-center justify-space-between flex-wrap">
            <div class="d-flex align-center mb-2 mb-sm-0">
              <v-icon color="primary" class="mr-2">mdi-storefront</v-icon>
              <span class="text-subtitle-1 font-weight-bold primary--text">Bancas Activas</span>
            </div>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar banca" hide-details dense outlined rounded class="modern-input search-input" style="max-width: 300px; width: 100%"></v-text-field>
          </div>
          <v-data-table :headers="headers" :items="items" :search="search" class="premium-table px-2 pb-2">
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon color="primary" class="glass-btn" @click="editItem(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <div class="pa-4 text-center">
                <v-btn color="primary" class="rounded-pill" @click="getData()"> Refrescar </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <!-- TAB: BANCA (FORM) -->
      <v-tab-item key="cia_nuevos">
        <v-form v-model="valid">
          
          <!-- Section 1: General -->
          <v-card class="glass-card mb-6 rounded-xl overflow-hidden" elevation="0">
            <div class="px-6 py-4 border-bottom header-glass">
              <div class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
                <span class="text-subtitle-1 font-weight-bold primary--text">Información General</span>
              </div>
            </div>
            <v-card-text class="pa-6">
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.companyId" label="Cédula" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="5">
                  <v-text-field v-model="editedItem.nombre" label="Nombre Banca" :rules="nameRules" required class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="editedItem.montoPermitido" label="Monto Maximo por sorteo" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto" type="number"></v-text-field>
                </v-col>
                
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.minutosAntesCierre" label="Minutos Antes Cierre" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto" type="number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field v-model="editedItem.porcPaga" label="% TICA" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto" type="number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field v-model="editedItem.porcPagaExt" label="% Extranjeras" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto" type="number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field v-model="editedItem.porcPagaReventando" label="% Reventado" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto" type="number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.porcPagaReventandoX" label="% Reventado X" class="modern-input" outlined dense rounded :disabled="incluirValid" hide-details="auto" type="number"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Section 2: Sorteos -->
          <v-card class="glass-card mb-6 rounded-xl overflow-hidden" elevation="0">
            <div class="px-6 py-4 border-bottom header-glass">
              <div class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-ticket-percent-outline</v-icon>
                <span class="text-subtitle-1 font-weight-bold primary--text">Asignación de Sorteos</span>
              </div>
            </div>
            <v-card-text class="pa-6">
              <v-row align="center">
                <v-col cols="12" sm="5" md="6">
                  <v-select label="Seleccionar Sorteo" item-text="descripcion" item-value="id" v-model="sorteoDropDown" :items="sorteos" @change="changeSorteos" :disabled="incluirValid" class="modern-input" outlined dense rounded hide-details></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-text-field v-model="sorteoeditedItem.montoPermitido" label="Monto Maximo" :disabled="incluirValid" class="modern-input" outlined dense rounded hide-details type="number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="text-center text-sm-left">
                  <v-btn color="primary" class="rounded-pill shadow-soft font-weight-bold px-6" height="40" @click="saveSorteos" :disabled="incluirValid">
                    <v-icon left>mdi-plus</v-icon>
                    Agregar
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table :headers="headersSorteos" :items="grupoSorteos" class="premium-table mt-4" hide-default-footer>
                <template v-slot:top>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card class="theme-aware-dialog">
                      <v-card-title class="text-h6 justify-center pt-6">¿Desea descartar este sorteo?</v-card-title>
                      <v-card-actions class="pb-6 justify-center">
                        <v-btn color="grey darken-1" text class="rounded-pill px-4" @click="closeDeleteSorteos">Cancelar</v-btn>
                        <v-btn color="error" class="rounded-pill px-6 shadow-soft" @click="deleteItemConfirmSorteos">Confirmar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                  <v-btn icon color="error" class="glass-btn-error" @click="deleteItemSorteos(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <!-- Section 3: Parámetros del sistema -->
          <v-card class="glass-card mb-6 rounded-xl overflow-hidden" elevation="0">
            <div class="px-6 py-4 border-bottom header-glass">
              <div class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-cogs</v-icon>
                <span class="text-subtitle-1 font-weight-bold primary--text">Parámetros del Sistema</span>
              </div>
            </div>
            <v-card-text class="pa-6">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-select label="Formato Tiquete (Version)" v-model="editedItem.formatVersion" :items="['GenerarTiqueteReportFor80mm', 'GenerarTiqueteReportFor80mmV2', 'GenerarTiqueteReportFor80mmV3']" :disabled="incluirValid" class="modern-input" outlined dense rounded hide-details="auto"></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="editedItem.diasLimiteCanje" label="Días Límite de Canje" :disabled="incluirValid" class="modern-input" outlined dense rounded hide-details="auto" type="number"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea label="Pie de página del tiquete" v-model="editedItem.footerText" name="input-7-1" class="modern-input" outlined rounded auto-grow rows="2" hide-details="auto"></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Actions -->
          <v-row justify="center" class="mt-4 mb-8">
            <v-col cols="auto">
              <v-btn color="info" :disabled="!incluirValid" @click="incluir()" class="rounded-pill px-8 font-weight-bold shadow-soft" height="46">
                <v-icon left>mdi-plus-circle-outline</v-icon>
                Nueva Banca
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn color="success" :disabled="!guardarValid" @click="save()" class="rounded-pill px-8 font-weight-bold shadow-soft" height="46">
                <v-icon left>mdi-content-save-outline</v-icon>
                Guardar
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn color="grey darken-1" dark :disabled="!cancelarValid" @click="cerrar()" class="rounded-pill px-8 font-weight-bold shadow-soft" height="46">
                <v-icon left>mdi-cancel</v-icon>
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-tab-item>
      
      <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";
//import Cabys from "./Cabys.vue";

export default {
  components: {
    Snackbar,
    //Cabys,
  },
  dark: true,
  data() {
    return {
      dialog: false,
      valid: false,
      incluirValid: true,
      cancelarValid: false,
      eliminarValid: false,
      guardarValid: false,
      existeSorteo: false,
      sorteoDropDown: "",
      formatVersion: "",
      footerText: "",
      diasLimiteCanje: 0,
      grupoSorteos: [],
      tiqueteConfigs: [],
      tiqueteFooters: [],
      search: "",
      snackText: "",
      snackValue: false,
      tab2: "",
      headers: [
        {
          text: "Cédula",
          align: "start",
          value: "companyId",
        },
        {
          text: "Nombre",
          align: "start",
          value: "nombre",
        },
        { text: "Editar", value: "actions", width: 50, sortable: false },
      ],
      headersSorteos: [
        {
          text: "Nombre",
          align: "start",
          value: "descripcion",
        },
        {
          text: "Monto Permitido",
          align: "start",
          value: "montoPermitido",
        },
        { text: "Eliminar", value: "delete", width: 70, sortable: false },
      ],
      items: [],
      sorteos: [],
      editedIndex: -1,
      editedItem: {
        nombre: "",
        companyId: "",
        porcPaga: 0,
        porcPagaExt: 0,
        minutosAntesCierre: 0,
        montoPermitido: 0,
        porcPagaReventando: 0,
        porcPagaReventandoX: 0,
        formatVersion: "",
        diasLimiteCanje: 0,
        footerText: "",
      },
      defaultItem: {
        nombre: "",
        companyId: "",
        porcPaga: 0,
        porcPagaExt: 0,
        minutosAntesCierre: 0,
        montoPermitido: 0,
        porcPagaReventando: 0,
        porcPagaReventandoX: 0,
        formatVersion: "",
        diasLimiteCanje: 0,
        footerText: "",
      },
      sorteoditedIndex: -1,
      sorteoeditedItem: {
        id: 0,
        descripcion: "",
        montoPermitido: 0,
      },
      sorteodefaultItem: {
        id: 0,
        descripcion: "",
        montoPermitido: 0,
      },
      tiqueteFootereditedItem: {
        value: 0,
        companyId: ""
      },
      tiqueteFooterdefaultItem: {
        value: 0,
        companyId: ""
      },

      tiqueteConfigeditedItem: {
        configKey: "",
        configValue: "",
        companyId: "",
      },
      tiqueteConfigdefaultItem: {
        configKey: "",
        configValue: "",
        companyId: "",
      },
      modeloCia: {
        cia: [],
        grupoSorteos: [],
        tiqueteConfig: [],
        tiqueteFooter: [],
      },
      showNewData: false,
      nameRules: [(v) => !!v || "Campo requerido"],
      tempFile: "",
      tempFileImage: "",
      modelFile: null,
      modelFileImage: null,
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    search() {
      this.snackValue = false;
    },
  },

  created() {
    this.getData();
    //this.getTiposIdentificacion();
  },

  methods: {
    getData() {
      let me = this;
      axios
        .get("api/Tiempos/getBancas", {
          crossdomain: true,
        })
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    limpiar() {
      this.snackValue = false;
    },

    getSorteos() {
      let me = this;
      axios
        .get("api/Tiempos/GetGrupoSorteos")
        .then(function (response) {
          me.sorteos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    closeDeleteSorteos() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.sorteoeditedItem = Object.assign({}, this.sorteodefaultItem);
        this.sorteoeditedIndex = -1;
      });
    },

    deleteItemSorteos(item) {
      this.sorteoeditedIndex = this.grupoSorteos.indexOf(item);
      this.sorteoeditedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirmSorteos() {
      this.grupoSorteos.splice(this.sorteoeditedIndex, 1);
      this.closeDeleteSorteos();
    },

    saveSorteos() {
      this.addNewSorteos();
    },

    changeSorteos() {
      this.getSorteo();
    },

    getSorteo() {
      let me = this;
      axios
        .get("api/Tiempos/GetGrupoSorteosById?id=" + this.sorteoDropDown, {
          crossdomain: true,
        })
        .then(function (response) {
          me.sorteoeditedItem = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getModeloCia() {
      let me = this;
      axios
        .get("api/Tiempos/GetModeloCia?companyId=" + this.editedItem.companyId, {
          crossdomain: true,
        })
        .then(function (response) {
          me.grupoSorteos = response.data.grupoSorteos;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    addNewSorteos() {
      this.existeSorteo = false;
      this.grupoSorteos.find((object) => {
        if (object.id === this.sorteoDropDown) {
          this.existeSorteo = true;
        }
      });

      if (this.existeSorteo === false) {
        if (this.sorteoeditedItem.id != "") {
          if (this.sorteoeditedIndex > -1) {
            // this.snackText = "Existe:" + this.existeCia;
            // this.snackValue = true;
          } else {
            this.grupoSorteos.push(this.sorteoeditedItem);
            this.existeSorteo = false;
          }
          this.closeSorteos();
        }
      }
    },

    closeSorteos() {
      this.dialog = false;
      this.$nextTick(() => {
        this.sorteoeditedItem = Object.assign({}, this.sorteodefaultItem);
        this.sorteoeditedIndex = -1;
      });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.getSorteos();
      this.getModeloCia();
      //this.changeProvincia();
      //this.changeCantones();
      //this.changeDistritos();
      //this.getActividades();
      this.tab2 = 1;
      this.cancelarValid = true;
      this.eliminarValid = true;
      this.guardarValid = true;
      this.incluirValid = false;
    },

    save() {
      let me = this;
      //this.editedItem.cia = this.strCia;
      this.modeloCia.cia = this.editedItem;
      this.modeloCia.grupoSorteos = this.grupoSorteos;

      if (this.editedIndex > -1) {
        axios
          .post("/api/Tiempos/UpdateModeloCia", this.modeloCia)
          .then(function () {
            me.snackText = "Registro modificado satisfactoriamente";
            me.snackValue = true;
            me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
      } else {
        axios
          .post("/api/Tiempos/InsertModeloCia", this.modeloCia)
          .then(function () {
            me.snackText = "Registro agregado satisfactoriamente";
            me.snackValue = true;
            me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
      }
      this.cancelarValid = true;
      this.eliminarValid = true;
      this.guardarValid = true;
      this.incluirValid = false;
      this.snackValue = false;
      //this.changeEsReceptor();
    },

    deleteItem() {
      let me = this;
      if (confirm("¿Está seguro de que desea eliminar el articulo?")) {
        axios
          .delete("api/Tiempos/deleteClientes?cia=" + this.editedItem.cedula)
          .then(function () {
            me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
        this.cerrar();
        this.tab2 = 0;
        this.esRec = false;
      }
    },

    closed() {
      this.showNewData = false;
      this.dialog = false;
    },

    cerrar() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.valid = false;
        this.cancelarValid = false;
        this.eliminarValid = false;
        this.guardarValid = false;
        this.incluirValid = true;
      });
    },

    onImageChange(ev) {
      this.tempFile = ev;
      this.editedItem.certificado = ev.name;
    },

    onChangeCiaImage(ev) {
      this.tempFileImage = ev;
      this.editedItem.imagePath = ev.name;
    },

    incluir() {
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.cancelarValid = true;
        this.eliminarValid = false;
        this.guardarValid = true;
        this.incluirValid = false;
        this.esRec = false;
        this.getSorteos();
      });
    },
  },
};
</script>

<style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

.glass-btn-error {
    background: rgba(244, 67, 54, 0.1) !important;
}

.header-glass {
    background: rgba(25, 118, 210, 0.03);
}

.theme--dark .header-glass {
    background: rgba(255, 255, 255, 0.02);
}

.border-bottom {
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.theme--dark .border-bottom {
    border-bottom: 1px solid rgba(255,255,255,0.05);
}

/* Modern Inputs */
.modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(255, 255, 255, 0.5) !important;
    backdrop-filter: blur(4px);
}

.theme--dark .modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(0, 0, 0, 0.2) !important;
}

/* Table Styling */
.premium-table {
    background: transparent !important;
}

.premium-table >>> th {
    background: rgba(0, 0, 0, 0.02) !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.75rem !important;
}

.theme--dark .premium-table >>> th {
    background: rgba(255, 255, 255, 0.05) !important;
}

.premium-table >>> tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

/* Tabs Styling */
.custom-tabs >>> .v-tabs-bar {
    background-color: transparent !important;
}

.transparent-tabs-item {
    background-color: transparent !important;
}

/* Text Utilities */
.letter-spacing-1 {
    letter-spacing: 1px;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

.shadow-soft {
    box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Theme Aware Dialog/Card */
.theme-aware-dialog {
    border-radius: 24px !important;
}

.theme-aware-card {
    background-color: var(--v-background-base, #ffffff) !important;
}

.theme--dark .theme-aware-card {
    background-color: var(--v-background-base, #1e1e2e) !important;
}

/* Legacy Overrides */
.cd {
  overflow: scroll;
}

.v-tabs-items {
  overflow: auto;
}

.botonSalir {
  position: fixed;
  top: 5px;
  right: 5px;
}
</style>